import React from 'react';
import { Facebook, Instagram, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-stone-900 text-stone-400 py-16" data-id="element-9">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-11">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1" data-id="element-12">
            <div className="flex items-center gap-2 mb-6" data-id="element-13">
              <img src="https://cdn.magicpatterns.com/uploads/6UAdBnZU6aG8byEmEcksLw/WBN-LOGO.png" alt="Well Balanced Nutrition" className="h-12 w-auto brightness-0 invert" data-id="element-14" />
            </div>
            <p className="text-sm leading-relaxed mb-6" data-id="element-15">
              Compassionate, evidence-based nutrition coaching for real life.
            </p>
            <div className="flex gap-4" data-id="element-16">
              <a href="#" className="hover:text-white transition-colors" data-id="element-17">
                <Facebook className="h-5 w-5" data-id="element-18" />
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-19">
                <Instagram className="h-5 w-5" data-id="element-20" />
              </a>
            </div>
          </div>

          {/* Locations */}
          <div className="col-span-1 md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-21">
            <div data-id="element-22">
              <h4 className="text-white font-bold mb-4" data-id="element-23">Clemmons Office</h4>
              <ul className="space-y-3 text-sm" data-id="element-24">
                <li className="flex gap-3" data-id="element-25">
                  <MapPin className="h-5 w-5 shrink-0" data-id="element-26" />
                  <span data-id="element-27">
                    123 Wellness Way, Suite 100
                    <br data-id="element-28" />
                    Clemmons, NC 27012
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-29">
                  <Phone className="h-5 w-5 shrink-0" data-id="element-30" />
                  <span data-id="element-31">(336) 555-0123</span>
                </li>
              </ul>
            </div>
            <div data-id="element-32">
              <h4 className="text-white font-bold mb-4" data-id="element-33">Durham Office</h4>
              <ul className="space-y-3 text-sm" data-id="element-34">
                <li className="flex gap-3" data-id="element-35">
                  <MapPin className="h-5 w-5 shrink-0" data-id="element-36" />
                  <span data-id="element-37">
                    456 Bull City Blvd, Suite 200
                    <br data-id="element-38" />
                    Durham, NC 27701
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-39">
                  <Phone className="h-5 w-5 shrink-0" data-id="element-40" />
                  <span data-id="element-41">(919) 555-0123</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Links */}
          <div data-id="element-42">
            <h4 className="text-white font-bold mb-4" data-id="element-43">Quick Links</h4>
            <ul className="space-y-2 text-sm" data-id="element-44">
              <li data-id="element-45">
                <a href="#" className="hover:text-white transition-colors" data-id="element-46">
                  Client Portal
                </a>
              </li>
              <li data-id="element-47">
                <a href="#" className="hover:text-white transition-colors" data-id="element-48">
                  For Providers
                </a>
              </li>
              <li data-id="element-49">
                <a href="#" className="hover:text-white transition-colors" data-id="element-50">
                  Blog & Resources
                </a>
              </li>
              <li data-id="element-51">
                <a href="#" className="hover:text-white transition-colors" data-id="element-52">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-53">
          <p data-id="element-54">
            &copy; {new Date().getFullYear()} Well Balanced Nutrition. All
            rights reserved.
          </p>
          <p className="flex items-center gap-2" data-id="element-55">
            <span className="h-2 w-2 rounded-full bg-emerald-500" data-id="element-56"></span>
            Accepting new clients (Virtual & In-Person)
          </p>
        </div>
      </div>
    </footer>;
}